const WOE_ADMIN2 = 9;
const WOE_COUNTRY = 12;
const NAME_FLAG_PREFERRED = 1;
const NAME_FLAG_ABBREVIATION = 2;

function getFeatureAbbreviation(feature: any, flags?: number[]): string | undefined {
  const abbrNames: any[] = (feature?.names || []).filter((n: any) => n?.lang === 'abbr');
  const flagged = flags?.length
    ? abbrNames.find(n => flags.every(f => (n.flags || []).indexOf(f) >= 0))?.name
    : undefined;
  return flagged || abbrNames[0]?.name;
}

function getAdmin2Abbreviation(interpretation: any): string | undefined {
  const domAbbr = (feat: any): string | undefined => {
    const a = getFeatureAbbreviation(feat, [NAME_FLAG_ABBREVIATION, NAME_FLAG_PREFERRED]);
    return a && /^[0-9]{3}$/.test(a) ? a : undefined;
  };
  const feature = interpretation?.feature;
  if (feature?.woeType === WOE_ADMIN2) return getFeatureAbbreviation(feature);
  if (feature?.woeType === WOE_COUNTRY) return domAbbr(feature);
  for (const parent of interpretation?.parents || []) {
    if (parent.woeType === WOE_ADMIN2) {
      const a = getFeatureAbbreviation(parent);
      if (a) return a;
    } else if (parent.woeType === WOE_COUNTRY) {
      const a = domAbbr(parent);
      if (a) return a;
    }
  }
  return undefined;
}

export function getPreferredLabel(interpretation: any): string {
  const name = interpretation.feature.name;
  const abbr = getAdmin2Abbreviation(interpretation);
  return abbr ? `${name} (${abbr})` : name;
}
